module.exports = __webpack_public_path__ + "static/media/boxolos_csaj_hatter.81be1b10.jpg";